<template>
  <div
    v-if="showPageBar"
    class="close-btn"
    @click="handleClose"
    :style="getIcoOfBg('closebtn')"
  ></div>
</template>

<script lang="ts" setup>
import { sdkCloseWebview } from '@utiles/sdkCtrl';
import { getIcoOfBg } from '@config/siteConfig';
import { useBaseStore } from '@store/base';
import { computed } from 'vue';
import { sendSessionEndPoint } from '@biPoint/sessionId';
const props = defineProps({
  moduleName: {
    default: '',
  },
});
const base = useBaseStore();
const showPageBar = computed(() => base.showPageBar);
const handleClose = () => {
  clickButtonPoint({
    btnName: 'close',
    moduleName: props.moduleName,
  });
  sendSessionEndPoint();
  sdkCloseWebview();
};
</script>
<style scoped lang="scss">
@import '@assets/scss/dimen.scss';
@import '@assets/scss/mixin.scss';
.close-btn {
  position: fixed;
  right: 0;
  top: 0;
  width: 112px;
  height: 112px;
  cursor: pointer;
  z-index: 2;
  @include addTouchEffect();
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .close-btn {
    width: calc(112px / $pcRate);
    height: calc(112px / $pcRate);
  }
}
</style>
